import React, {useEffect, useState} from "react";
import TableReport from "../../components/TableReport/TableReport";
import {FormControl, InputLabel, MenuItem, Select, TextField, Tooltip} from "@mui/material";
import {DimensionamentoService} from "../../services/DimensionamentoServices";
import LoadingAnimation from "../Loading/LoadingAnimation";
import Swal from "sweetalert2";

const DimensionamentoReport = () => {

  const [filters, setFilters] = useState({
    seeCityLevel: false,
    seeMicroLevel: false,
    seeMacroLevel: false,
    seeStateLevel: false,
    searchField: "",
    openAllCells: false,
    fillByMissingOrSurplus: null,
  })

  const [selected, setSelected] = useState({
    selectedCity: {},
    selectedMicro: {},
    selectedMacro: {},
    selectedState: {},
    selectedObjCity: null,
  })

  const [originData, setOriginData] = useState({
    cities: [],
    micros: [],
    macros: [],
    states: [],
    originalCityObj: [],
    data: {
      highComplexity: [],
      mediumComplexity: [],
      lowComplexity: [],
    },
    backupData: {
      highComplexity: [],
      mediumComplexity: [],
      lowComplexity: [],
    },
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    DimensionamentoService.fetchCities().then((res) => {
      setOriginData(prevState => ({
        ...prevState,
        originalCityObj: res
      }));
      let cities = [];
      let macros = [];
      let micros = [];
      let states = [];
      res.forEach((city) => {
        cities.push(city.city);
        micros.push(city.microRegiao);
        macros.push(city.macroRegiao);
        states.push(city.state);
      });
      setOriginData(prevState => ({
        ...prevState,
        cities: [...new Set(cities)],
        micros: [...new Set(micros)],
        macros: [...new Set(macros)],
        states: [...new Set(states)],
      }));
      setSelected(prevState => ({
        ...prevState,
        selectedCity: "Nan",
        selectedMicro: "Nan",
        selectedMacro: "Nan",
        selectedState: "Nan",
      }));
    });
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      const dados = await DimensionamentoService.getReportComplexity();
      setOriginData(prevState => ({
        ...prevState,
        backupData: dados
      }));
    };
    fetchData();

  }, []);

  useEffect(() => {
    if (selected.selectedObjCity !== "Nan") {
      setLoading(true);
      DimensionamentoService.getReportComplexity(selected.selectedObjCity).then((res) => {
        if(!selected.selectedObjCity) {
          setLoading(false);
          return;
        }

        setFilters(prevState => ({
          ...prevState,
          searchField: ""
        }));
        if(!res) return
        let highComplexity = res.highComplexity
        let mediumComplexity = res.mediumComplexity
        let lowComplexity = res.lowComplexity

        setOriginData(prevState => ({
          ...prevState,
          data: {
            highComplexity: highComplexity,
            mediumComplexity: mediumComplexity,
            lowComplexity: lowComplexity
          },
          backupData: {
            highComplexity: highComplexity,
            mediumComplexity: mediumComplexity,
            lowComplexity: lowComplexity
          }
        }));
        setLoading(false);
      }).catch((error) => {
        console.error('Erro ao buscar os dados:', error);
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar os dados',
          text: 'Por favor, contate um administrador.',
        });

      })
    }
  }, [selected.selectedObjCity, selected.selectedCity, selected.selectedMicro, selected.selectedMacro, selected.selectedState]);

  function originalValues(citiesObj = originData.originalCityObj) {
    let cities = [];
    let macros = [];
    let micros = [];
    let states = [];
    citiesObj.forEach((city) => {
      cities.push(city.city);
      micros.push(city.microRegiao);
      macros.push(city.macroRegiao);
      states.push(city.state);
    });
    setOriginData(prevState => ({
      ...prevState,
      cities: [...new Set(cities)],
      micros: [...new Set(micros)],
      macros: [...new Set(macros)],
      states: [...new Set(states)],
    }));
    setSelected(prevState => ({
      ...prevState,
      selectedCity: "Nan",
      selectedMicro: "Nan",
      selectedMacro: "Nan",
      selectedState: "Nan",
    }));
  }

  const selectCity = (event) => {
    if (event.target.value === "Nan") {
      setFilters(prevState => ({
        ...prevState,
        seeCityLevel: false
      }))
      setSelected(prevState => ({
        ...prevState,
        selectedCity: "Nan",
      }))
      return;
    }
    let cityObj = originData.originalCityObj.find((city) => city.city === event.target.value);
    setSelected(prevState => ({
      ...prevState,
      selectedCity: cityObj.city,
      selectedMicro: cityObj.microRegiao,
      selectedMacro: cityObj.macroRegiao,
      selectedState: cityObj.state,
      selectedObjCity: cityObj
    }))
  }

  const selectMicro = (event) => {
    if (event.target.value === "Nan") {
      setSelected(prevState => ({
        ...prevState,
        selectedCity: "Nan",
        selectedMicro: "Nan",
      }));
      setFilters(prevState => ({
        ...prevState,
        seeMicroLevel: false,
        seeCityLevel: false
      }))
      return;
    }
    let newCities = [];
    let cityObj = originData.originalCityObj.find((city) => city.microRegiao === event.target.value);
    originData.originalCityObj.forEach((city) => {
      if (city.microRegiao === event.target.value) {
        newCities.push(city.city);
      }
    });
    setOriginData(prevState => ({
      ...prevState,
      cities: [...new Set(newCities)],
    }));
    setFilters(prevState => ({
      ...prevState,
      seeCityLevel: false
    }))
    setSelected(prevState => ({
      ...prevState,
      selectedCity: "Nan",
      selectedMicro: cityObj.microRegiao,
      selectedMacro: cityObj.macroRegiao,
      selectedState: cityObj.state,
      selectedObjCity: cityObj
    }));
  }

  const selectMacro = (event) => {
    if (event.target.value === "Nan") {
      originalValues();
      return;
    }
    let cityObj = originData.originalCityObj.find((city) => city.macroRegiao === event.target.value);
    let newMicros = [];
    originData.originalCityObj.forEach((city) => {
      if (city.macroRegiao === event.target.value) {
        newMicros.push(city.microRegiao);
      }
    });
    setOriginData(prevState => ({
      ...prevState,
      micros: [...new Set(newMicros)],
    }));
    setFilters(prevState => ({
      ...prevState,
      seeCityLevel: false,
      seeMicroLevel: false
    }))

    setSelected(prevState => ({
      ...prevState,
      selectedCity: "Nan",
      selectedMicro: "Nan",
      selectedMacro: cityObj.macroRegiao,
      selectedState: cityObj.state,
      selectedObjCity: cityObj
    }))
  }

  const selectState = (event) => {
    if (event.target.value === "Nan") {
      originalValues();
      return;
    }
    let newCities = [];
    let newMicros = [];
    let newMacros = [];
    let cityObj = originData.originalCityObj.find((city) => city.state === event.target.value);
    originData.originalCityObj.forEach((city) => {
      if (city.state === event.target.value) {
        newCities.push(city.city);
        newMicros.push(city.microRegiao);
        newMacros.push(city.macroRegiao);
      }
    });
    setOriginData(prevState => ({
      ...prevState,
      cities: [...new Set(newCities)],
      micros: [...new Set(newMicros)],
      macros: [...new Set(newMacros)],
    }));
    setFilters(prevState => ({
      ...prevState,
      seeCityLevel: false,
      seeMicroLevel: false,
      seeMacroLevel: false
    }))
    setSelected(prevState => ({
      ...prevState,
      selectedCity: "Nan",
      selectedMicro: "Nan",
      selectedMacro: "Nan",
      selectedState: cityObj.state,
      selectedObjCity: "Nan"
    }))
  }

  const onChangeSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setOriginData(prevState => ({
      ...prevState,
      data: {
        highComplexity: prevState.backupData.highComplexity.filter(item => item.parameterName.toLowerCase().startsWith(searchValue)),
        mediumComplexity: prevState.backupData.mediumComplexity.filter(item => item.parameterName.toLowerCase().startsWith(searchValue)),
        lowComplexity: prevState.backupData.lowComplexity.filter(item => item.parameterName.toLowerCase().startsWith(searchValue)),
      }
    }));
    setFilters(prevState => ({
      ...prevState,
      searchField: searchValue
    }))
  };

  const selectMissing = (event) => {
    const value = event.target.value;
    setFilters(prevState => ({
      ...prevState,
      fillByMissingOrSurplus: value === "Insuficiencia" ? true
        : value === "Excesso" ? false
        : value === "Suficiencia" ? "equal"
        : null

    }));
  }

  return (
    <div className="w-full h-full flex flex-col justify-between items-center">
      <h1 className="text-lg font-medium">Selecione uma região</h1>
      <div className="flex flex-col items-center justify-center gap-3 lg:flex-row pb-2 pt-4 w-full sm:w-2/3 lg:w-full">
        <FormControl sx={{
            width: {
              xs: '100%',
              sm: '260px',
            },
          }}
        >
          <InputLabel
            id="select-city-label">Município</InputLabel>
          <Select
            variant='outlined'
            labelId="select-city-label"
            id="selectCity"
            value={selected.selectedCity}
            label="Município"
            onChange={selectCity}
          >
            <MenuItem value="Nan">Selecione um
              município</MenuItem>
            {originData.cities.map((city, index) => (
              <MenuItem key={index}
                        value={city}>{city}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{
          width: {
            xs: '100%',
            sm: '260px',
          },
        }}
        >
          <InputLabel
            id="select-micro-label">Micro-região</InputLabel>
          <Select
            variant='outlined'
            labelId="select-micro-label"
            id="selectMicro"
            value={selected.selectedMicro}
            label="Micro-região"
            onChange={selectMicro}
          >
            <MenuItem value="Nan">Selecione uma
              micro-região</MenuItem>
            {originData.micros.map((micro, index) => (
              <MenuItem key={index}
                        value={micro}>{micro}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{
          width: {
            xs: '100%',
            sm: '260px',
          },
        }}
        >
          <InputLabel
            id="select-macro-label">Macro-região</InputLabel>
          <Select
            variant='outlined'
            labelId="select-macro-label"
            id="selectMacro"
            value={selected.selectedMacro}
            label="Macro-região"
            onChange={selectMacro}
          >
            <MenuItem value="Nan">Selecione uma
              macro-região</MenuItem>
            {originData.macros.map((macro, index) => (
              <MenuItem key={index}
                        value={macro}>{macro}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Tooltip title="Selecionar o estado não altera o resultado do relatório." arrow placement="top">
          <FormControl
            sx={{
              width: {
                xs: '100%',
                sm: '260px',
              },
            }}
          >
            <InputLabel id="select-state-label">Estado</InputLabel>
            <Select
              variant='outlined'
              labelId="select-state-label"
              id="selectState"
              value={selected.selectedState}
              label="Estado"
              onChange={selectState}
            >
              <MenuItem value="Nan">Selecione um estado</MenuItem>
              {originData.states.map((state, index) => (
                <MenuItem key={index} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Tooltip>
      </div>

      <div className={"w-full flex flex-col lg:flex-row justify-between items-center lg:pt-6 pt-2"}>

        <FormControl fullWidth sx={{m: 1}}>
          <TextField
            rows={1}
            id="searchField"
            label="Pesquisar"
            onChange={(event) => onChangeSearch(event)}
            value={filters.searchField}
          />
        </FormControl>
        <div className='flex flex-col sm:flex-row items-center justify-between w-full lg:w-auto'>

          <FormControl sx={{
            width: {
              xs: '100%',
              sm: '220px',
            },
          }}
          >
            <InputLabel id="select-filter-label">Filtro</InputLabel>
            <Select
              variant='outlined'
              labelId="select-filter-label"
              id="selectFilter"
              label="Micro-região"
              onChange={selectMissing}
              defaultValue={"Nan"}
            >
              <MenuItem key={0} value="Nan">Selecione um filtro</MenuItem>
              <MenuItem key={1} value="Suficiencia">Suficiência de rede</MenuItem>
              <MenuItem key={2} value="Insuficiencia">Insuficiência de rede</MenuItem>
              <MenuItem key={3} value="Excesso">Excesso de rede</MenuItem>
            </Select>
          </FormControl>
          {filters.openAllCells ?
            <button
              className="bg-red-700 hover:bg-red-900 text-white px-4 rounded-md min-w-36 h-14 shadow-md w-full lg:w-auto lg:mt-0 mt-2 mx-2"
              onClick={() => {
                setFilters(prevState => ({
                  ...prevState,
                  openAllCells: !prevState.openAllCells
                }))
              }}>Fechar todos</button>
            :
            <button
              className="bg-emerald-700 hover:bg-emerald-900 text-white px-4 rounded-md min-w-36 h-14 shadow-md w-full lg:w-auto lg:mt-0 mt-2 mx-2"
              onClick={() => {
                setFilters(prevState => ({
                  ...prevState,
                  openAllCells: !prevState.openAllCells
                }))
              }}>Abrir todos</button>}
        </div>
      </div>
      <div className="pt-5 w-full h-full pb-6">
        {/*<TableReport data={state.data} openAll={state.openAll}/>*/}
        {loading ?
          <LoadingAnimation />
          : (
            <>
              <TableReport title="Rede Assistencial de BAIXA Complexidade"
                           description="Oferece atendimento aos beneficiários no município.
                           Casos que demandem especialidades não disponíveis localmente serão encaminhados
                            para municípios da microrregião ou macrorregião de saúde, considerando a proximidade
                             e a disponibilidade de serviços."
                           data={originData.data.lowComplexity}
                           showCityLevel={filters.seeCityLevel}
                           showMicroLevel={filters.seeMicroLevel}
                           showMacroLevel={filters.seeMacroLevel}
                           state={filters.openAllCells}
                           filterMissing={filters.fillByMissingOrSurplus}
                           city={selected}
                           tableType={"DimensionamentoReport"}
              />
              <TableReport title="Rede assistencial de MÉDIA Complexidade"
                           description="Atende beneficiários do município e
                            da microrregião de saúde. Casos que demandem especialidades
                             não disponíveis localmente serão encaminhados para o município da macrorregião,
                              priorizando a proximidade e a disponibilidade de serviços."
                           data={originData.data.mediumComplexity}
                           showCityLevel={filters.seeCityLevel}
                           showMicroLevel={filters.seeMicroLevel}
                           showMacroLevel={filters.seeMacroLevel}
                           state={filters.openAllCells}
                           filterMissing={filters.fillByMissingOrSurplus}
                           city={selected}
                           tableType={"DimensionamentoReport"}
              />
              <TableReport title="Rede assistencial de ALTA Complexidade"
                           description="Atende beneficiários do município, microrregião e macrorregião de saúde.
                           O município sede da macrorregião deve assegurar a capacidade de atendimento para demandas
                           não cobertas nas redes assistenciais dos municípios e microrregiões."
                           data={originData.data.highComplexity}
                           showCityLevel={filters.seeCityLevel}
                           showMicroLevel={filters.seeMicroLevel}
                           showMacroLevel={filters.seeMacroLevel}
                           state={filters.openAllCells}
                           filterMissing={filters.fillByMissingOrSurplus}
                           city={selected}
                           tableType={"DimensionamentoReport"}
              />
            </>
          )
        }
      </div>
    </div>
  );
}

export default DimensionamentoReport;